/**
 * N90 — Banner de "Simular Permissão" (portado do Thesys).
 * Faixa fixa no topo enquanto o MASTER está navegando como outro usuário.
 * Lê o claim `simulado_por` do token ativo; botão encerra a simulação.
 */
import { useEffect, useState } from 'react';
import { VenetianMask } from 'lucide-react';
import authService from '../services/authService';
import useAuthStore from '../stores/authStore';

export function SimulacaoBanner() {
  const [alvo, setAlvo] = useState<string | null>(null);
  const encerrarSimulacao = useAuthStore((s: any) => s.encerrarSimulacao);
  const user = useAuthStore((s: any) => s.user);

  useEffect(() => {
    authService.decodeActiveToken().then((p: any) => {
      if (p && p.simulado_por) {
        setAlvo((p.email || '').split('@')[0] || 'usuário');
      } else {
        setAlvo(null);
      }
    });
  }, [user]);

  if (!alvo) return null;

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
        background: '#f59e0b',
        color: '#1f1300',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        fontSize: 14,
        fontWeight: 600,
        boxShadow: '0 1px 4px rgba(0,0,0,.15)',
      }}
    >
      <VenetianMask size={18} />
      <span>
        Simulando permissões de <b>{alvo}</b> — modo somente leitura (nada é gravado no nome dele)
      </span>
      <button
        onClick={() => encerrarSimulacao()}
        style={{
          background: '#1f1300',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          padding: '4px 12px',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Encerrar simulação
      </button>
    </div>
  );
}

export default SimulacaoBanner;
